import { getCloudinaryId } from '@masterplandev/utils'

import { CloudImageOptions, GetCloudImageUrl } from '../types'
import { getCloudinaryUrl } from './cloudinary'

/**
 * Converts image options object to Cloudflare transformation string
 */
function getTransformations(options: CloudImageOptions): string {
  const transformations: string[] = []

  // Map of option keys to their Cloudflare parameter names
  const paramMap: Record<keyof CloudImageOptions, string> = {
    background: 'background',
    width: 'w',
    height: 'h',
    quality: 'q',
    dpr: 'dpr',
    fit: 'fit',
    format: 'f',
    gravity: 'g',
  }

  // Convert each option to its Cloudflare parameter format
  Object.entries(options).forEach(([key, value]) => {
    if (
      value !== undefined &&
      key in paramMap &&
      paramMap[key as keyof CloudImageOptions]
    ) {
      const param = paramMap[key as keyof CloudImageOptions]
      const encodedValue =
        key === 'background'
          ? encodeURIComponent(String(value)).replace(
              /[()]/g,
              (character) =>
                `%${character.charCodeAt(0).toString(16).toUpperCase()}`,
            )
          : value
      transformations.push(`${param}=${encodedValue}`)
    }
  })

  return transformations.join(',')
}

/**
 * Get the Cloudflare image URL
 */
export const getCloudflareImageUrl: GetCloudImageUrl = (id, options) => {
  const cloudinaryUrl = getCloudinaryUrl()
  const cloudinaryId = getCloudinaryId(id)
  const sourceImageUrl = `${cloudinaryUrl}/${cloudinaryId}`

  const cloudflareUrl = '/cdn-cgi/image'
  const transformations = getTransformations({
    format: 'auto',
    ...options,
  })

  return `${cloudflareUrl}/${transformations}/${sourceImageUrl}`
}
